define('appkit/appkit',['require','exports','module','underscore','./app','./controller','./resource.manager','./util/deparam','./util/key.prefixer','./util/bind.radio','./controller.service','./module.loader','./router','./service.util'],function(require, exports, module) {
  var _ = require('underscore');

  exports.App               = require('./app');
  exports.Controller        = require('./controller');
  exports.ResourceManager   = require('./resource.manager');
  exports.util              = {};
  exports.util.deparam      = require('./util/deparam');
  exports.util.KeyPrefixer  = require('./util/key.prefixer');
  exports.util.bindRadio    = require('./util/bind.radio');
  exports.controllerService = require('./controller.service')
  exports.ModuleLoader      = require('./module.loader');
  exports.Router            = require('./router');

  _.extend(exports, require('./service.util'));
});

